import * as React from "react";
import type { SVGProps } from "react";
const SvgRadioOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <circle cx={10} cy={10} r={10} fill="#18A09F" />
    <circle cx={10} cy={10} r={4.167} fill="#F8F8F8" />
  </svg>
);
export default SvgRadioOn;
